export class Acesso {
    idDocumentoTramite: number;    
    codigoAcesso: string;
    chaveAcesso: string;
    emailDestinatario: string;
    dataGeracaoAcesso: Date;
    token : string;
    login : string;
    senha : string;
    urlDestino : string;
}



